import * as Yup from 'yup';

import { CreateTeamsField } from '@converge/data';

export const CreateTeamsFieldsSchema = Yup.object({
  [CreateTeamsField.TeamName]: Yup.string().required(),

  [CreateTeamsField.UwRegion]: Yup.string().optional().nullable(),
  [CreateTeamsField.PrimaryContact]: Yup.string().optional().nullable(),

  [CreateTeamsField.PrimaryContactEmail]: Yup.string().optional().nullable(),
  [CreateTeamsField.BusinessDevelopmentManager]: Yup.string()
    .optional()
    .nullable(),
  [CreateTeamsField.Underwriter]: Yup.string().optional().nullable(),
  [CreateTeamsField.BDMRegion]: Yup.string().optional().nullable(),
});
